import { NotificationContentType } from "@features/notifications/domain";

const viewProgressCases = new Set([
  NotificationContentType.PRODUCT_LOCK_QUANTITY_EXPIRING,
  NotificationContentType.PRODUCT_LOCK_TIME_EXPIRING,
  NotificationContentType.PRODUCT_LOCK_REMOVED,
  NotificationContentType.PRODUCT_LOCK_CREATED,
  NotificationContentType.PRODUCT_LOCK_UPDATED,
]);

export const shouldShowViewProgress = (
  contentType: NotificationContentType,
): boolean => viewProgressCases.has(contentType);
